var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/Search/ui/Search.less";
import { SearchBar, ComponentTypeMap, UpcommingEvent } from "../components";
import { SearchResultsState, PersonalizedViewState } from "../../../data";
import { Loader } from "sb-resp-ui";
let Search = class Search extends React.Component {
    constructor(props) {
        super(props);
        this.renderSearchResults = () => {
            return (React.createElement(React.Fragment, null, this.state.searchResults.map(this.renderSearchResult)));
        };
        this.renderSearchResult = (result) => {
            const Comp = ComponentTypeMap[result.componentType];
            return React.createElement(Comp, { key: result.id, result: result });
        };
        this.renderPersonalizedSection = () => {
            if (!this.state.hasPersonalizedSection) {
                return React.createElement(React.Fragment, null);
            }
            if (this.state.personalizedResultsState === PersonalizedViewState.Loader) {
                return React.createElement(Loader, null);
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "rj-search-result-title", "data-uat": "div-search-personalized-results-title" }, this.state.dict.RecommendedResults),
                this.state.personalizedResults.map(result => React.createElement(UpcommingEvent, { key: result.id, result: result }))));
        };
        this.renderRecentsSection = () => {
            if (this.state.hasRecentSection) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "rj-search-result-head" },
                        React.createElement("div", { className: "rj-search-result-title", "data-uat": "div-search-recent-results-title" }, this.state.dict.RecentResults),
                        React.createElement("div", { className: "rj-search-result-clear-all", onClick: this.state.clearRecents }, this.state.dict.ClearAll)),
                    this.state.recentResults.map(this.renderSearchResult)));
            }
            return false;
        };
        this.state = props.dataProvider;
        this.clickHandler = this.props.dataProvider.clickHandler;
    }
    componentDidMount() {
        if (this.props.dataProvider.isDesktop) {
            document.addEventListener("click", this.clickHandler);
        }
        else {
            const fakeInput = document.getElementById("fake-input");
            this.state.searchBarInput && this.state.searchBarInput.focus();
            if (fakeInput) {
                fakeInput.remove();
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.clickHandler);
    }
    render() {
        const { dict, setQuery, clearQuery, closeClickHandler, setSearchBarInput, searchResultsState, formattedSearchResultsLength, isDesktop, clearAndClose, setSearchBar, searchFocusHandler, hasFocus, hasSearchResultsSection, hasSearchResultContainer } = this.props.dataProvider;
        return (React.createElement("div", { className: "rj-bet-search-container", "data-uat": "div-search-container", ref: setSearchBar },
            isDesktop ?
                React.createElement(SearchBar, { query: this.state.query, setQuery: setQuery, clearQuery: clearAndClose, searchFocusHandler: searchFocusHandler, isDesktop: isDesktop, hasFocus: hasFocus, placeholder: dict.Placeholder })
                :
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "rj-bet-search__overlay" }),
                        React.createElement(SearchBar, { query: this.state.query, setSearchBarInput: setSearchBarInput, setQuery: setQuery, clearQuery: clearQuery, isDesktop: isDesktop },
                            React.createElement("div", { className: "rj-bet-search-cancel", "data-uat": "div-search-cancel-button" },
                                React.createElement("span", { onClick: closeClickHandler, "data-uat": "span-search-cancel-button" }, dict.Cancel)))),
            hasSearchResultContainer &&
                React.createElement("div", { className: "rj-bet-search__wrap", style: { height: this.state.wrapperHeight } },
                    React.createElement("div", { className: "rj-bet-search__inner" },
                        hasSearchResultsSection &&
                            React.createElement(React.Fragment, null, searchResultsState === SearchResultsState.Loading
                                ? React.createElement(Loader, null)
                                : React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "rj-search-result-title", "data-uat": "div-search-search-results-title" },
                                        dict.SearchResults,
                                        " ",
                                        formattedSearchResultsLength),
                                    searchResultsState === SearchResultsState.NoResults
                                        ? React.createElement("div", { className: "rj-bet-search__no-result", "data-uat": "div-search-no-result-div" }, dict.NoSearchResults)
                                        : this.renderSearchResults())),
                        this.renderRecentsSection(),
                        this.renderPersonalizedSection()))));
    }
};
Search = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], Search);
export { Search };
//# sourceMappingURL=Search.js.map